var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.withThumbnail
    ? _c(
        "a",
        {
          class: [
            { active: !!_vm.getVideoCodes(_vm.featuredMatches, _vm.imgParams) },
          ],
          attrs: { href: _vm.matchUrl(_vm.featuredMatches, _vm.imgParams) },
        },
        [
          _c("img", {
            attrs: {
              src: _vm.match_image(_vm.featuredMatches, _vm.imgParams),
              alt: _vm.featuredMatches.name,
              importance: "high",
            },
          }),
        ]
      )
    : _c("article", { staticClass: "article-item home-featured" }, [
        _c("div", { staticClass: "article-wrap" }, [
          _c("div", { staticClass: "article-thumbnail" }, [
            _c("div", { staticClass: "img-box" }, [
              _c(
                "a",
                {
                  class: [
                    {
                      active: !!_vm.getVideoCodes(
                        _vm.featuredMatches,
                        _vm.imgParams
                      ),
                    },
                  ],
                  attrs: {
                    href: _vm.matchUrl(_vm.featuredMatches, _vm.imgParams),
                  },
                },
                [
                  _vm.lazyImgType
                    ? _c("img", {
                        staticClass: "lazy",
                        attrs: {
                          src: _vm.defaultImg[_vm.lazyImgType],
                          "data-src": _vm.match_image(
                            _vm.featuredMatches,
                            _vm.imgParams
                          ),
                          alt: _vm.featuredMatches.name,
                        },
                      })
                    : _c("img", {
                        attrs: {
                          src: _vm.match_image(
                            _vm.featuredMatches,
                            _vm.imgParams
                          ),
                          alt: _vm.featuredMatches.name,
                        },
                      }),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "article-content" }, [
            _c(
              "a",
              {
                attrs: {
                  href: _vm.matchUrl(_vm.featuredMatches, _vm.imgParams),
                },
              },
              [
                _c("div", { staticClass: "match-item" }, [
                  _c("div", {
                    staticClass: "match-date",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.getDateTimeString(_vm.featuredMatches)
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "match-data" }, [
                    _c("div", { staticClass: "team team-A" }, [
                      _c("div", { staticClass: "team-name" }, [
                        _c("p", { staticClass: "article-title" }, [
                          _vm._v(_vm._s(_vm.generateHeadline())),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ]
            ),
          ]),
        ]),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }